var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrosoftTeams = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#microsoft-teams_svg__a)",
  d: "M32.316 26.947h20.21c5.575 0 10.106 4.53 10.106 10.106v16.842c0 5.574-4.53 10.105-10.106 10.105-5.574 0-10.105-4.53-10.105-10.105V37.053c0-5.575-4.53-10.106-10.105-10.106"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#microsoft-teams_svg__b)",
  d: "M8.737 33.684c0-5.574 4.53-10.105 10.105-10.105h13.474c5.575 0 10.105 4.53 10.105 10.105v20.21C42.421 59.47 46.951 64 52.526 64H25.58c-9.297 0-16.842-7.545-16.842-16.842z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#microsoft-teams_svg__c)",
  fillOpacity: 0.7,
  d: "M8.737 33.684c0-5.574 4.53-10.105 10.105-10.105h13.474c5.575 0 10.105 4.53 10.105 10.105v20.21C42.421 59.47 46.951 64 52.526 64H25.58c-9.297 0-16.842-7.545-16.842-16.842z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#microsoft-teams_svg__d)",
  fillOpacity: 0.7,
  d: "M8.737 33.684c0-5.574 4.53-10.105 10.105-10.105h13.474c5.575 0 10.105 4.53 10.105 10.105v20.21C42.421 59.47 46.951 64 52.526 64H25.58c-9.297 0-16.842-7.545-16.842-16.842z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#microsoft-teams_svg__e)",
  d: "M50.842 23.579a8.424 8.424 0 0 0 8.421-8.421 8.424 8.424 0 0 0-8.42-8.421 8.424 8.424 0 0 0-8.422 8.42 8.424 8.424 0 0 0 8.421 8.422"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#microsoft-teams_svg__f)",
  fillOpacity: 0.46,
  d: "M50.842 23.579a8.424 8.424 0 0 0 8.421-8.421 8.424 8.424 0 0 0-8.42-8.421 8.424 8.424 0 0 0-8.422 8.42 8.424 8.424 0 0 0 8.421 8.422"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#microsoft-teams_svg__g)",
  fillOpacity: 0.4,
  d: "M50.842 23.579a8.424 8.424 0 0 0 8.421-8.421 8.424 8.424 0 0 0-8.42-8.421 8.424 8.424 0 0 0-8.422 8.42 8.424 8.424 0 0 0 8.421 8.422"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#microsoft-teams_svg__h)",
  d: "M25.579 20.21c5.575 0 10.105-4.53 10.105-10.105C35.684 4.531 31.154 0 25.58 0S15.474 4.53 15.474 10.105s4.53 10.106 10.105 10.106"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#microsoft-teams_svg__i)",
  fillOpacity: 0.6,
  d: "M25.579 20.21c5.575 0 10.105-4.53 10.105-10.105C35.684 4.531 31.154 0 25.58 0S15.474 4.53 15.474 10.105s4.53 10.106 10.105 10.106"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#microsoft-teams_svg__j)",
  fillOpacity: 0.5,
  d: "M25.579 20.21c5.575 0 10.105-4.53 10.105-10.105C35.684 4.531 31.154 0 25.58 0S15.474 4.53 15.474 10.105s4.53 10.106 10.105 10.106"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#microsoft-teams_svg__k)",
  d: "M23.474 32h-16A5.474 5.474 0 0 0 2 37.474v16a5.474 5.474 0 0 0 5.474 5.473h16a5.474 5.474 0 0 0 5.473-5.473v-16A5.474 5.474 0 0 0 23.474 32"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#microsoft-teams_svg__l)",
  fillOpacity: 0.7,
  d: "M23.474 32h-16A5.474 5.474 0 0 0 2 37.474v16a5.474 5.474 0 0 0 5.474 5.473h16a5.474 5.474 0 0 0 5.473-5.473v-16A5.474 5.474 0 0 0 23.474 32"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.335 40.607h-4.126v12.58h-3.47v-12.58H9.613v-2.83h11.722z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "microsoft-teams_svg__a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(22.7032 0 0 56.0337 63.576 31.04)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A98AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#8C75FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#5F50E2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#3C2CB8"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "microsoft-teams_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(68.15 -8.079 18.746)scale(55.1579 55.7811)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#85C2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#7588FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6459FE"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "microsoft-teams_svg__d",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(113.33 13.667 29.613)scale(32.3705 25.9874)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BD96FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#BD96FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "microsoft-teams_svg__e",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 -16.8421 21.2547 0 50.38 12.716)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#6868F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3923B1"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "microsoft-teams_svg__f",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(9.21803 7.74856 -11.2056 13.33066 51.969 20.241)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#A1D3FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#A1D3FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "microsoft-teams_svg__g",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-41.66 55.012 -72.816)scale(14.3326 35.1663)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E3ACFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#9FA2FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "microsoft-teams_svg__h",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 -20.2105 25.5158 0 26.694 7.141)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#8282FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3923B1"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "microsoft-teams_svg__i",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(40.05 -4.354 43.89)scale(14.4505 20.8842)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#A1D3FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#A1D3FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "microsoft-teams_svg__j",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-41.66 33.51 -52.325)scale(17.2126 42.2063)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E3ACFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#9FA2FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "microsoft-teams_svg__k",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(45 -39.427 20.571)scale(38.1137)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#688EFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#230F94"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "microsoft-teams_svg__l",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 18.8632 -22.0126 0 22.26 54.875)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#6965F6",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8F8FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "microsoft-teams_svg__c",
  x1: 30.632,
  x2: 30.632,
  y1: 30.316,
  y2: 70.737,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#6864F6",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5149DE"
})))));
export default SvgMicrosoftTeams;